import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { sportsRadarService } from "../../services/sportsRadarService";
import RefreshIcon from "@mui/icons-material/Refresh";
import Loader from "../../sharedComponents/loader/loader";
import { AppDataContext } from "../../common/appContext";
import {
  Box,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";

const useStyles = makeStyles((theme) => ({
  bgBlue: {
    height: "100vh",
    background:
      "-webkit-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
    background:
      "-moz-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
    background:
      "-o-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
    background:
      "-ms-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
    background:
      "linear-gradient(to bottom, #1d428a 230px, #f6f6f6 21px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
  },
  root: {
    display: "flex",
    padding: theme.spacing(1),
    border: "solid 1px #ccc",
    fontSize: "10px !important",
  },

  gridContainer: {
    margin: "15px",
    border: "1px solid lightgrey",
    borderRadius: "none",
    padding: theme.spacing(2),
  },
  appbarBackground: {
    backgroundColor: "#fff",
    color: "#1d428a",
  },
  headRow: {
    "& th": {
      backgroundColor: "#1d428a",
      color: "#fff",
    },
  },

  refreshTD: {
    verticalAlign: "top",
    "& svg": {
      cursor: "pointer",
    },
  },
  drgContainer: {
    height: "calc(100vh - 170px)",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "10px",
      height: "10px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#bdbdbd",
    },
    "&::-webkit-scrollbar-thumb": {
      boxShadow: "inset 0 0 8px rgba(0, 0, 0, 0.7)",
    },
  },
  tbl: {
    "& thead tr th": {
      fontSize: "0.75rem",
    },
    "& tbody tr td": {
      fontSize: "0.75rem",
    },
    "& tbody tr:hover td:not([rowSpan])": {
      backgroundColor: "#d5e2fb",
      fontWeight: "bold",
    },
  },
}));

export default function () {
  const classes = useStyles();
  const { user, combineYear } = useContext(AppDataContext);
  const [loading, setLoading] = useState(false);
  const [sportsRadarData, setSportsRadarData] = useState([]);
  const [sportsRadarDataCopy, setSportsRadarDataCopy] = useState([]);
  const [playerNameSearchText, setPlayerNameSearchText] = useState("");

  function GetPlayerDataLength(playerId) {
    return sportsRadarDataCopy.filter((r) => r.playerID == playerId).length;
  }

  const searchPlayerOrCollegeName = (searchValue) => {
    setPlayerNameSearchText(searchValue);
    if (searchValue) {
      if (searchValue.length > 1) {
        const tempData = [...sportsRadarData];
        const updatedPlayerData = tempData.filter((elem) => {
          return (
            elem.playerName.toLowerCase().includes(searchValue.toLowerCase()) ||
            elem.collegeOrClub.toLowerCase().includes(searchValue.toLowerCase())
          );
        });
        setSportsRadarDataCopy(updatedPlayerData);
      }
    } else {
      setSportsRadarDataCopy([...sportsRadarData]);
    }
  };

  async function refreshPlayerData(playerId, srPlayerId) {
    try {
      setLoading(true);
      let response = await sportsRadarService.refreshPlayerDetails(
        combineYear,
        playerId,
        srPlayerId,
        user.userID,
        "",
        user?.loginID
      );
      let data = await response.data;
      let cnt = GetPlayerDataLength(playerId);
      let index = sportsRadarData.findIndex((r) => r.playerID === playerId);
      let arr = [...sportsRadarData];
      arr.splice(index, cnt, ...data);
      setSportsRadarData([...arr]);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  }

  async function GetData() {
    try {
      setLoading(true);
      let response = await sportsRadarService.getPlayerListByCombineYear(
        combineYear,
        0
      );
      let data = await response.data;
      setSportsRadarData(data);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    GetData();
  }, []);

  useEffect(() => {
    setSportsRadarDataCopy([...sportsRadarData]);
  }, [sportsRadarData]);

  let pName = "",
    pId = 0,
    cnt = 0,
    newRecord = false,
    cellColorCntr = 0,
    selectedCellColor = "";
  let cellColors = ["#f5f5f5", "#fff"];
  return (
    <>
      <Grid container p={1} className={classes.root}>
        <Grid item xs={12} mb={1}>
          <Grid container spacing={2}>
            <Grid item lg={5} md={6} sm={6} xs={12}>
              <FormControl fullWidth>
                <TextField
                  size="small"
                  label="Type min 2 characters to search Player or College Name"
                  fullWidth
                  value={playerNameSearchText || ""}
                  onChange={(e) => searchPlayerOrCollegeName(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {playerNameSearchText !== "" && (
                          <IconButton
                            aria-label="Clear Search"
                            onClick={(e) => searchPlayerOrCollegeName("")}
                            edge="end"
                          >
                            <ClearIcon color="secondary" />
                          </IconButton>
                        )}
                        <IconButton aria-label="Search" edge="end">
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <TableContainer className={classes.drgContainer}>
            <Table
              stickyHeader
              aria-label="sticky table"
              className={classes.tbl}
            >
              <TableHead>
                <TableRow className={classes.headRow}>
                  <TableCell>Refresh</TableCell>
                  <TableCell>Player Name</TableCell>
                  <TableCell>College/Club</TableCell>
                  <TableCell>Season Year</TableCell>
                  <TableCell>Height</TableCell>
                  <TableCell>Weight</TableCell>
                  <TableCell>Position</TableCell>
                  <TableCell>Jersey#</TableCell>
                  <TableCell>Experience</TableCell>
                  <TableCell>Birth Place</TableCell>
                  <TableCell>Team Name</TableCell>
                  <TableCell>Team Market</TableCell>
                  <TableCell>GP</TableCell>
                  <TableCell>GS</TableCell>
                  <TableCell>Min</TableCell>
                  <TableCell>FGM</TableCell>
                  <TableCell>FGA</TableCell>
                  <TableCell>FG%</TableCell>
                  <TableCell>2PM</TableCell>
                  <TableCell>2PA</TableCell>
                  <TableCell>2P%</TableCell>
                  <TableCell>3PM</TableCell>
                  <TableCell>3PA</TableCell>
                  <TableCell>3P%</TableCell>
                  <TableCell>FTM</TableCell>
                  <TableCell>FTA</TableCell>
                  <TableCell>FT%</TableCell>
                  <TableCell>ORB</TableCell>
                  <TableCell>DRB</TableCell>
                  <TableCell>REB</TableCell>
                  <TableCell>AST</TableCell>
                  <TableCell>TO</TableCell>
                  <TableCell>STL</TableCell>
                  <TableCell>BLK</TableCell>
                  <TableCell>PF</TableCell>
                  <TableCell>TF</TableCell>
                  <TableCell>PTS</TableCell>
                  <TableCell>FF</TableCell>
                  <TableCell>TS%</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sportsRadarDataCopy.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={100}>No records found.</TableCell>
                  </TableRow>
                )}
                {sportsRadarDataCopy.length > 0 &&
                  sportsRadarDataCopy.map((obj, index) => {
                    if (pName !== obj.playerName && pId !== obj.playerID) {
                      newRecord = true;
                      cnt = GetPlayerDataLength(obj.playerID);
                      pName = obj.playerName;
                      pId = obj.playerID;
                      selectedCellColor = cellColors[++cellColorCntr % 2];
                    } else {
                      newRecord = false;
                    }
                    return (
                      <TableRow
                        key={index}
                        style={{ backgroundColor: selectedCellColor }}
                      >
                        {newRecord && (
                          <TableCell
                            rowSpan={cnt}
                            className={classes.refreshTD}
                          >
                            {obj.sportRadarPlayerID && (
                              <RefreshIcon
                                onClick={() =>
                                  refreshPlayerData(
                                    obj.playerID,
                                    obj.sportRadarPlayerID
                                  )
                                }
                              />
                            )}
                          </TableCell>
                        )}
                        <TableCell>{obj.playerName}</TableCell>
                        <TableCell>{obj.collegeOrClub}</TableCell>
                        <TableCell>{obj.seasonYear}</TableCell>
                        <TableCell>{obj.height}</TableCell>
                        <TableCell>{obj.weight}</TableCell>
                        <TableCell>{obj.position}</TableCell>
                        <TableCell>{obj.jerseyNumber}</TableCell>
                        <TableCell>{obj.experience}</TableCell>
                        <TableCell>{obj.birthPlace}</TableCell>
                        <TableCell>{obj.teamName}</TableCell>
                        <TableCell>{obj.teamMarket}</TableCell>
                        <TableCell>{obj.gamesPlayed}</TableCell>
                        <TableCell>{obj.gamesStarted}</TableCell>
                        <TableCell>{obj.minutes}</TableCell>
                        <TableCell>{obj.fieldGoalsMade}</TableCell>
                        <TableCell>{obj.fieldGoalsAtt}</TableCell>
                        <TableCell>{obj.fieldGoalsPct}</TableCell>
                        <TableCell>{obj.twoPointsMade}</TableCell>
                        <TableCell>{obj.twoPointsAtt}</TableCell>
                        <TableCell>{obj.twoPointsPct}</TableCell>
                        <TableCell>{obj.threePointsMade}</TableCell>
                        <TableCell>{obj.threePointsAtt}</TableCell>
                        <TableCell>{obj.threePointsPct}</TableCell>
                        <TableCell>{obj.freeThrowsMade}</TableCell>
                        <TableCell>{obj.freeThrowsAtt}</TableCell>
                        <TableCell>{obj.freeThrowsPct}</TableCell>
                        <TableCell>{obj.offensiveRebounds}</TableCell>
                        <TableCell>{obj.defensiveRebounds}</TableCell>
                        <TableCell>{obj.rebounds}</TableCell>
                        <TableCell>{obj.assists}</TableCell>
                        <TableCell>{obj.turnovers}</TableCell>
                        <TableCell>{obj.steals}</TableCell>
                        <TableCell>{obj.blocks}</TableCell>
                        <TableCell>{obj.personalFouls}</TableCell>
                        <TableCell>{obj.techFouls}</TableCell>
                        <TableCell>{obj.points}</TableCell>
                        <TableCell>{obj.flagrantFouls}</TableCell>
                        <TableCell>{obj.trueShootingPct}</TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <Loader isLoading={loading} />
        </Grid>
      </Grid>
    </>
  );
}
